var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"cols":"12"}},_vm._l((_vm.stacks),function(stack){return _c('StackView',_vm._g({key:stack.id,attrs:{"stack":stack,"projections":_vm.projections}},_vm.$listeners))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }